import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23808e6a")

_pushScopeId("data-v-23808e6a")
const _hoisted_1 = { class: "row container" }
const _hoisted_2 = { class: "nav-tree" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "col h-full align-center" }
const _hoisted_5 = { class: "demo-buttons w-full text-end flex" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("直接上传")
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("查看结构")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("初次发布")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_category_tree = _resolveComponent("category-tree")
  const _component_el_input = _resolveComponent("el-input")
  const _component_tag_filter = _resolveComponent("tag-filter")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_publish_dialog = _resolveComponent("publish-dialog")
  const _component_demo_form = _resolveComponent("demo-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_category_tree, {
          currentCategoryId: _ctx.currentCategoryId,
          categoryType: "DEMO",
          onNodeClick: _ctx.filterCategory
        }, null, 8, ["currentCategoryId", "onNodeClick"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_el_input, {
              placeholder: "请输入名称",
              modelValue: _ctx.searchName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchName = $event)),
              class: "input-with-select"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_tag_filter, {
              modelValue: _ctx.filterTags,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterTags = $event)),
              onSearch: _ctx.search
            }, null, 8, ["modelValue", "onSearch"]),
            _hoisted_6,
            (!_ctx.isSelectorMode)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  class: "font-20",
                  icon: "el-icon-circle-plus-outline",
                  onClick: _ctx.uploadDemo
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_table, {
            data: _ctx.tableData.content,
            height: "100%",
            onRowClick: _ctx.viewStructure,
            class: "w-full"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "名称",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "category",
                label: "分类",
                width: "80"
              }, {
                default: _withId((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.category.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "audio",
                label: "音频"
              }, {
                default: _withId((scope) => [
                  (scope.row.demoUrl)
                    ? (_openBlock(), _createBlock("audio", {
                        key: 0,
                        src: scope.row.demoUrl,
                        controls: ""
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "tags",
                width: "260px",
                label: "标签"
              }, {
                default: _withId((scope) => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.tags, (tag) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: scope.row.id + '-' + tag.id
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(tag.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "fileSize",
                width: "80px",
                label: "大小"
              }, {
                default: _withId((scope) => [
                  _createVNode("div", null, _toDisplayString(scope.row.fileSize ? `${(scope.row.fileSize / 1024 / 1024).toFixed(2)}M` : ''), 1)
                ]),
                _: 1
              }),
              (!_ctx.isSelectorMode)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    fixed: "right",
                    label: "操作"
                  }, {
                    default: _withId(({row}) => [
                      _createVNode("div", _hoisted_8, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          class: "margin-right-10",
                          onClick: _withModifiers(($event: any) => (_ctx.edit(row)), ["stop"]),
                          type: "info"
                        }, {
                          default: _withId(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          size: "small",
                          class: "margin-right-10",
                          onClick: _withModifiers(($event: any) => (_ctx.viewStructure(row)), ["stop"]),
                          type: "warning"
                        }, {
                          default: _withId(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (row.latestVersion < 1)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              size: "small",
                              class: "margin-right-10",
                              onClick: _withModifiers(($event: any) => (_ctx.openDialogForPublish(row)), ["stop"]),
                              type: "success"
                            }, {
                              default: _withId(() => [
                                _hoisted_11
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_popconfirm, {
                          onConfirm: ($event: any) => (_ctx.deleteDemo(row)),
                          title: "确定删除吗？"
                        }, {
                          reference: _withId(() => [
                            _createVNode(_component_el_button, {
                              size: "small",
                              type: "danger"
                            }, {
                              default: _withId(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data", "onRowClick"]),
          _hoisted_13,
          _createVNode(_component_el_pagination, {
            class: "margin-top-10",
            total: _ctx.tableData.totalCount,
            "page-count": _ctx.tableData.totalPages,
            "current-page": _ctx.tableData.pageNumber,
            onCurrentChange: _ctx.reloadPage,
            onPrevClick: _ctx.reloadPage,
            onNextClick: _ctx.reloadPage,
            background: "",
            layout: "total, prev, pager, next, jumper"
          }, null, 8, ["total", "page-count", "current-page", "onCurrentChange", "onPrevClick", "onNextClick"])
        ])
      ])
    ]),
    _createVNode(_component_publish_dialog, {
      modelValue: _ctx.publishDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.publishDialogVisible = $event)),
      onConfirm: _ctx.publish
    }, null, 8, ["modelValue", "onConfirm"]),
    _createVNode(_component_el_dialog, {
      title: "上传成品",
      modelValue: _ctx.demoDialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.demoDialogVisible = $event)),
      width: "40%"
    }, {
      default: _withId(() => [
        _createVNode(_component_demo_form, {
          demo: _ctx.demo,
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.demoDialogVisible = false)),
          onSuccess: _ctx.demoCreated
        }, null, 8, ["demo", "onSuccess"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})